import { render, staticRenderFns } from "./home-box3.vue?vue&type=template&id=00dae7df&scoped=true&"
import script from "./home-box3.vue?vue&type=script&lang=js&"
export * from "./home-box3.vue?vue&type=script&lang=js&"
import style0 from "./home-box3.vue?vue&type=style&index=0&id=00dae7df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dae7df",
  null
  
)

export default component.exports